"use strict";
/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The result type of of RemoteServers LIST_REMOTE_SERVERS service
 */
var ListRemoteServersResult = /** @class */ (function () {
    /**
     * Create a new ListRemoteServersResult instance
     *
     * @param result  the array of remote servers
     */
    function ListRemoteServersResult(result) {
        this.result = result;
    }
    return ListRemoteServersResult;
}());
exports.ListRemoteServersResult = ListRemoteServersResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/list-remote-servers-result.js
// module id = 1341
// module chunks = 1